import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, Check } from "lucide-react";
import { API, pesanGalat } from "../lib/api";
import { useAuth } from "../auth";

const JANJI = [
  "Data perusahaan Anda terpisah penuh, tidak tercampur dengan perusahaan lain.",
  "Surat yang terbit bernomor dan bisa dicek siapa pun tanpa membuka data pribadi.",
  "Tidak ada kata sandi pegawai yang pernah masuk ke sini.",
];

export default function Daftar() {
  const [f, setF] = useState({ nama_perusahaan: "", nama: "", email: "", password: "" });
  const [galat, setGalat] = useState(null);
  const [muat, setMuat] = useState(false);
  const { setUser } = useAuth();
  const nav = useNavigate();

  const kirim = async (e) => {
    e.preventDefault();
    setMuat(true); setGalat(null);
    try {
      const r = await API.post("/perusahaan/daftar", f);
      localStorage.setItem("pamit_token", r.data.token);
      setUser(r.data.pengguna);
      nav("/buku");
    } catch (err) { setGalat(pesanGalat(err)); } finally { setMuat(false); }
  };

  const kelas = "mt-1.5 w-full border rounded px-3 py-2.5 text-sm";

  return (
    <div className="min-h-screen flex flex-col">
      <header className="kaca border-b">
        <div className="max-w-[1000px] mx-auto px-4 md:px-8 h-14 flex items-center justify-between">
          <Link to="/" data-testid="tautan-beranda" className="flex items-center gap-2">
            <ShieldCheck size={18} className="text-primary" aria-hidden="true" />
            <span className="font-heading font-bold text-lg">PAM-IT</span>
          </Link>
          <Link to="/masuk" data-testid="tautan-masuk" className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">
            Sudah punya akun
          </Link>
        </div>
      </header>

      <main className="halaman-kerja flex-1 px-4 py-14 max-w-[1000px] w-full mx-auto grid gap-10 md:grid-cols-[1fr_360px]">
        <div>
          <p className="label-kecil">Daftar gratis</p>
          <h1 className="mt-4 text-4xl sm:text-5xl font-bold" data-testid="judul-daftar">
            Buka ruang kerja untuk perusahaan Anda
          </h1>
          <p className="mt-4 text-muted-foreground max-w-xl leading-relaxed">
            Isi tiga kolom, dan Anda langsung jadi Admin IT di ruang kerja sendiri. Isinya masih kosong,
            jadi Anda bisa mulai dari sistem yang paling sering bikin repot.
          </p>
          <ul className="mt-8 space-y-3">
            {JANJI.map((j) => (
              <li key={j} className="flex gap-3 text-sm text-muted-foreground">
                <Check size={17} className="text-primary shrink-0 mt-0.5" aria-hidden="true" />
                <span>{j}</span>
              </li>
            ))}
          </ul>
        </div>

        <form onSubmit={kirim} className="panel rounded p-6 h-fit space-y-4" data-testid="form-daftar">
          <div>
            <label htmlFor="d-pt" className="label-kecil">Nama perusahaan</label>
            <input id="d-pt" data-testid="input-nama-perusahaan" required value={f.nama_perusahaan}
              onChange={(e) => setF({ ...f, nama_perusahaan: e.target.value })} className={kelas} />
          </div>
          <div>
            <label htmlFor="d-nama" className="label-kecil">Nama Anda</label>
            <input id="d-nama" data-testid="input-nama-admin" required value={f.nama}
              onChange={(e) => setF({ ...f, nama: e.target.value })} className={kelas} />
          </div>
          <div>
            <label htmlFor="d-email" className="label-kecil">Email kerja</label>
            <input id="d-email" data-testid="input-email-daftar" type="email" required value={f.email}
              onChange={(e) => setF({ ...f, email: e.target.value })} className={kelas} />
          </div>
          <div>
            <label htmlFor="d-sandi" className="label-kecil">Kata sandi (minimal 8 karakter)</label>
            <input id="d-sandi" data-testid="input-sandi-daftar" type="password" required minLength={8}
              value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className={kelas} />
          </div>
          {galat && <p data-testid="galat-daftar" className="text-sm text-destructive">{galat}</p>}
          <button data-testid="btn-daftar" disabled={muat} className="tombol-utama w-full px-4 py-3 rounded text-sm disabled:opacity-50">
            {muat ? "Menyiapkan ruang kerja…" : "Buat ruang kerja"}
          </button>
          <p className="text-xs text-muted-foreground">
            Mau lihat-lihat dulu? <Link to="/demo" className="underline">Buka data contoh</Link>.
          </p>
        </form>
      </main>
    </div>
  );
}
